export default __webpack_public_path__ + "static/media/shopbag.f11f05bc.png";